import React from "react";
import FeatureType from "./FeatureType";
import Point from "./Point";
import Polygon from "./Polygon";


const Feature = ({data}) => {
    const type = data.geometry.type;
    switch (type) {
        case FeatureType.POINT:
            return <Point data={data}/>;
        case FeatureType.POLYGON:
            return <Polygon data={data} />;
        default:
            return null;
    }
};

export default Feature;